export function ErrorAlert({ error }) {
  if (!error) {
    return null;
  }

  return (
    <div className="wp:mb-8 wp:rounded-md wp:border wp:border-solid wp:border-red-200 wp:bg-red-50 wp:p-4 wp:text-base wp:text-red-800">
      {error}
    </div>
  );
}
/** @param {{ children: import("react").ReactNode }} props */
